import * as React from "react";
import styled, { css } from "styled-components";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LOADING_ROW_HEIGHT } from "logview/components/LogViewTable";
import { Spinner } from "components/common";
import WidgetContext from "views/components/contexts/WidgetContext";
import { isInfiniteScrollUp } from "logview/helpers";
const LoadingIndicator = styled.div(
  ({ theme }) => css`
    min-height: ${LOADING_ROW_HEIGHT}px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-family: ${theme.fonts.family.body};
    font-size: ${theme.fonts.size.body};
  `
);
const _directionDescriptor = (infiniteScrollDirection, sort) => {
  if (isInfiniteScrollUp(infiniteScrollDirection)) {
    if (sort === "DESC") {
      return "previous";
    }
    return "next";
  }
  if (sort === "DESC") {
    return "next";
  }
  return "previous";
};
const LoadMoreRow = ({ infiniteScrollDirection }) => {
  const widget = useContext(WidgetContext);
  const directionDescriptor = _directionDescriptor(infiniteScrollDirection, widget.config.sort);
  const { t } = useTranslation("enterprise_search");
  const direction = directionDescriptor === "previous" ? t("load_more_row.previous") : t("load_more_row.next");
  return /* @__PURE__ */ React.createElement(LoadingIndicator, { key: "loading-test" }, /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: t("load_more_row.loading_messages", { direction }) }));
};
export default LoadMoreRow;
